import React, { useState } from "react";
import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  ListSubheader,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import { CampaignMaterialType, CampaignState } from "../service/campaigns.types";
import TextFieldWrapper from "modules/Forms/components/textFIeldWrapper.component";
import { useJustification } from "modules/UI/hooks/useJustification.hook";
import { FileRejection, DropEvent } from "react-dropzone";
import { MediaFileSchema } from "../service/campaigns.schemas";
import CampaignsService from "../service/campaigns.service";
import * as yup from "yup";
import { Remove, Add } from "@mui/icons-material";
import { toast } from "react-toastify";
import { useActiveUser, useActiveUserScope } from "modules/User/activeUser";
import Dropzone from "modules/Forms/components/dropzone.component";
import { useLocalizedMarkets } from "../service/campaigns.hooks";


enum incoTermOptions {
  "FOB",
  "DDP"
};

export const CampaignMaterialPreOrderButton = (props) => {
  const { allMaterials, material, campaign, requests, onRefetch } = props;
  const [quantity, setQuantity] = useState(material.minimumPurchaseQuantity);
  const currentUser = useActiveUser();
  const currentUserScope = useActiveUserScope();
  const incoTermValue = allMaterials[0]?.incoTerms || campaign?.incoTerms;
  const [openIncoItermPopUp, setOpenIncoItermPopUp] = useState(false);
  const { data: markets = [] } = useLocalizedMarkets(material?.orderWindowId);
  const canPreOrder =
    !currentUser.isViewOnly() &&
    (campaign.state === CampaignState.Active ||
      campaign.state === CampaignState.Pending_Market_Proc);
  const requestQuote = useJustification({
    title: `Your order`,
    description: "Your comments",
    submitButtonText: `Submit`,
    isJustificationFieldOptional: true,
    additionalData: [
      {
        key: "quantity",
        initialValue: quantity,
        validationSchema: yup
          .number()
          .required()
          .min(
            material.minimumPurchaseQuantity,
            "Minimum quantity is " + material.minimumPurchaseQuantity
          )
          .test(
            "multiples-of-mpq",
            "Quantity values must be multiples of Minimum Pack Quantity (MPQ)",
            function (value, context) {
              // const quantities = context.from[1].value.priceRanges.map(
              //   (range) => range.threshold
              // );
              return value % material.minimumPurchaseQuantity === 0;
            }
          ),
      },
      {
        key: "mediaFiles",
        initialValue: [],
        validationSchema: yup.array().of(MediaFileSchema).notRequired(),
      },
      {
        key: "incoTerm",
        initialValue: {
          id: incoTermOptions[allMaterials[0]?.incoTerms || campaign?.incoTerms], name: allMaterials[0]?.incoTerms || campaign?.incoTerms
        },
        validationSchema: yup
          .object()
          .shape({
            id: yup.string().required(),
            name: yup.string().required(),
          })
          .notRequired()
        // .required("Market is required"),
      },
      {
        key: "market",
        initialValue: null,
        validationSchema: yup
          .object()
          .shape({
            id: yup.string().required(),
            name: yup.string().required(),
          })
          .required("Market is required"),
      },
    ],
    additionalContent: ({ values, setFieldValue }) => (
      <div>
        <Grid
          container
          spacing={2}
          justifyContent={"space-between"}
          alignItems={"center"}
          sx={{ mt: 2 }}
        >
          <Grid item xs={6}>
            IncoTerm
          </Grid>
          <Grid item xs={6}>
            <Select
              fullWidth
              size="small"
              value={incoTermOptions[values.incoTerm.id]}
              onChange={(e) => {
                if (e.target.value !== incoTermValue) {
                  setOpenIncoItermPopUp(true)
                }
                setFieldValue("incoTerm", {
                  id: incoTermOptions[e.target.value],
                  name: e.target.value,
                });
              }}
            >
              <MenuItem key={"FOB"} value={"FOB"}>FOB</MenuItem>
              <MenuItem key={"DDP"} value={"DDP"}>DDP</MenuItem>
            </Select>
          </Grid>
          <Grid item xs={12}>
            <TextFieldWrapper name="quantity" label="Quantity" fullWidth />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <Dropzone
              placeholder={
                "You can optionaly attach a file by dropping it here"
              }
              fileName={values.mediaFiles[0]?.originalFileName}
              onRemoveFile={
                values.mediaFiles.length === 0
                  ? null
                  : (fileName) => {
                    CampaignsService.deleteQuantityRequestMedia({
                      fileId: values.mediaFiles[0]?.fileId,
                    }).then(() => {
                      setFieldValue("mediaFiles", []);
                    });
                  }
              }
              onDrop={async function <T extends File>(
                acceptedFiles: T[],
                fileRejections: FileRejection[],
                event: DropEvent
              ): Promise<void> {
                CampaignsService.uploadQuantityRequestMedia({
                  file: acceptedFiles[0],
                }).then((result) => {
                  setFieldValue("mediaFiles", [result]);
                });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={6}>
            Location
          </Grid>
          <Grid item xs={6}>
            {/* <Select
              fullWidth
              size="small"
              value={values.market?.id}
              onChange={(e) => {
                setFieldValue("market", {
                  id: e.target.value,
                  name: e.target.value,
                });
              }}
            >
              {currentUserScope.scopeTree
                .filter((zoneScope) => {
                  return zoneScope.markets.some((marketScope) => {
                    return !!campaign.markets.find(
                      (m) => m.id === marketScope.market.id
                    );
                  });
                })
                .map((zoneScope) => {
                  return [
                    <ListSubheader>---{zoneScope.zone.name}---</ListSubheader>,
                    zoneScope.markets
                      .filter((marketScope) => {
                        return !!campaign.markets.find(
                          (m) => m.id === marketScope.market.id
                        );
                      })
                      .map((marketScope) => (
                        <MenuItem
                          key={marketScope.market.id}
                          value={marketScope.market.id}
                          disabled={
                            requests?.requests
                              .some(req => req.market.id === marketScope.market.id && req.requestor === currentUser.email)
                          }
                        >
                          {marketScope.market.name}{" "}
                          {requests?.requests
                            .some(req => req.market.id === marketScope.market.id && req.requestor === currentUser.email) ? (
                            <> - you have already requested</>
                          ) : (
                            <></>
                          )}
                        </MenuItem>
                      )),
                  ];
                })}
              <MenuItem />
            </Select> */}
            <Select
              fullWidth
              size="small"
              value={values.market?.id || ""}
              onChange={(e) => {
                const selected = markets.find(
                  (m: any) => m.id === Number(e.target.value)
                );

                setFieldValue("market", {
                  id: selected?.id,
                  name: selected?.name,
                });
              }}
            >
              {markets?.length > 0 ? (
                markets.map((market: any) => {
                  const isAlreadyRequested = requests?.requests?.some(
                    (req) =>
                      req.market.id === market.id &&
                      req.requestor === currentUser.email
                  );

                  return (
                    <MenuItem
                      key={market.id}
                      value={market.id}
                      disabled={isAlreadyRequested}
                    >
                      {market.name}
                      {isAlreadyRequested ? " - you have already requested" : ""}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem disabled>No markets available</MenuItem>
              )}
            </Select>
          </Grid>
        </Grid>
      </div>
    ),
  });
  return (
    <>
      {requestQuote.JSX}
      <Box textAlign={"center"}>
        {canPreOrder && (
          <ButtonGroup variant="outlined" color="primary">
            <Tooltip arrow title="Decrease quantity">
              <Button
                disabled={quantity <= material.minimumPurchaseQuantity}
                onClick={() => {
                  setQuantity((prev) => prev - material.minimumPurchaseQuantity);
                }}
              >
                <Remove />
              </Button>
            </Tooltip>
            <Tooltip
              arrow
              title={
                material.canOrderQuantities
                  ? "Pre-Order"
                  : "You are not configured to Order Quantity for this Market."
              }
            >
              <Button
                size="large"
                variant="contained"
                disabled={material.canOrderQuantities !== true}
                onClick={() => {
                  requestQuote
                    .requestJustification()
                    .then((data) => {
                      CampaignsService.requestMaterialQuantity({
                        ...data,
                        requestor: currentUser.email,
                        comments: data.justification,
                        quantity: data.quantity,
                        orderWindowMaterialId: material.id,
                      })
                        .then((result) => {
                          toast.success("Pre-order was successful.");
                          if (onRefetch) onRefetch();
                        })
                        .catch((e) => {
                          toast.error("Something went wrong.");
                          if (onRefetch) onRefetch();
                        });
                      setQuantity(material.minimumPurchaseQuantity);
                    })
                    .catch(() => {
                      setQuantity(material.minimumPurchaseQuantity);
                      if (onRefetch) onRefetch();
                    });
                }}
              >
                Pre-Order {quantity} {material.unitOfMeasure}
              </Button>
            </Tooltip>
            <Tooltip arrow title="Increase quantity">
              <Button
                onClick={() => {
                  setQuantity((prev) => prev + material.minimumPurchaseQuantity);
                }}
              >
                <Add />
              </Button>
            </Tooltip>
          </ButtonGroup>
        )}
        {/* <FormHelperText sx={{ textAlign: "center" }}>
          est. cost{" "}
          {quantity *
            [...material.priceRanges]
              .sort((a, b) => {
                return a.threshold < b.threshold ? 1 : -1;
              })
              .find((r) => quantity >= r.threshold)?.unitPrice}{" "}
          {material.currencyCode}
        </FormHelperText> */}

        <Dialog
          open={openIncoItermPopUp}
          onClose={() => setOpenIncoItermPopUp(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {"Are You Sure?"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Order window campaign price needs to be reviewed and updated. Supplier will  reach to you.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenIncoItermPopUp(false)}>Ok</Button>
          </DialogActions>
        </Dialog>

      </Box>
    </>
  );
};

export default CampaignMaterialPreOrderButton;
